var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"border-0 rounded-full \\\n\t\tfocus:outline-none \\\n\t\tdark:text-white dark:border-0",attrs:{"title":_vm.message},on:{"click":function () { return this$1.$emit('button-clicked'); }}},[_c('font-awesome-icon',{staticClass:"inline-block",attrs:{"icon":_vm.icon,"size":"lg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }